import { Component, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ProductService } from '../product.service';
import { HttpClient, HttpRequest, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthService } from '../auth.service';
import { AuthManagerService } from '../auth-manager.service';
import { CategoryService } from '../category.service';
import { ViewportScroller } from '@angular/common';
import { RemoveQuotesPipe } from '../remove-quotes.pipe';


@Component({
  selector: 'app-giftvouchers',
  templateUrl: './giftvouchers.component.html',
  styleUrls: ['./giftvouchers.component.css']
})
export class GiftvouchersComponent implements OnInit, AfterViewInit {

  @ViewChild('scratch', { static: false }) scratchCanvasRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild('prize', { static: false }) prizeElRef!: ElementRef<HTMLDivElement>;

  ctx!: CanvasRenderingContext2D;
  scratching = false;

  // products: any[] = [];
  // previousPrizes: string[] = [];
  // selectedPrize: string = '';
  // chancesLeft = 3;

  totalPixels = 0;
  scratchedPixels = 0;
  prizeRevealed = false;

    // @ViewChild('scratch') scratchCanvasRef!: ElementRef<HTMLCanvasElement>;
    // @ViewChild('prize') prizeElRef!: ElementRef;

    private prizes: any[] = [];
    private scratchArea: { x: number, y: number, width: number, height: number } = { x: 0, y: 0, width: 0, height: 0 };
    // private scratchedPixels = 0;
    // private totalPixels = 0;

    categoryId: any;
    voucher_category_id: any;
    m_voucher_id: any;
    // member_type: any;
    token: any = "609615431cd8d539b733876c7e0c511dSAGLcHZ6nxEBnE4XlJ1nmcPTZaOXOGIXW"
    products: any[] = [];
    profileData: any;
    bearerToken: any;
    selectedProduct: any;
    selectedPrice: number = 0;
    quantity: number = 1;
    remainingBalance: any;
    vouchersAvailable: number = 0;
    selectedIndex: any;
    categoryName: any;
    showDetailsSection: boolean = false;
    
    termsAndConditions: any; 
    termsLink: any;
    showTerms: boolean = false;
    expanded: boolean = false;
    bannerImage: string = 'assets/images/breadcurmb/pose_joy.jpg';
    bodyBackgroundImage: string = '';
    

    private currentScratchProgress: number = 0;
    private storedPrize: string = '';
    public chancesLeft: number = 3;
    public previousPrizes: string[] = [];
    public scratchCount: number = 0;

    public displayedPrizes: string[] = [];
    public currentPrizeIndex: number = 0;
    public selectedPrize: string = '';
    public selectedPrizeCode: string = '';
    public prizeRevealedOnce: boolean = false;
    
    constructor(
      private route: ActivatedRoute,
      private router: Router,
      private productService: ProductService,
      private http: HttpClient,
      private authService: AuthService,
      private categoryService: CategoryService,
      private authManager: AuthManagerService,
      private scroller: ViewportScroller,
      private location: Location
    ) { }
    
      ngOnInit(): void {
        window.scrollTo(0, 0);
        this.profileData = localStorage.getItem('profileData');
        this.bearerToken = localStorage.getItem('bearerToken');
        this.route.queryParams.subscribe(params => {
          this.categoryId = +params['categoryId'];
          // this.fetchProducts();
        });
        this.remainingBalance = this.selectedProduct?.remaining_voucher_amount || 0;
        this.resetLinkColors();
        this.onCardClick(this.selectedProduct);

        window.onbeforeunload = () => {
          localStorage.removeItem('mobile_number');
        };

        const isEventOngoing = localStorage.getItem('event') === '1';
        this.bannerImage = isEventOngoing ? 'assets/images/breadcurmb/joy_refer.jpg' : 'assets/images/breadcurmb/diwali.jpg';
        // this.bodyBackgroundImage = isEventOngoing ? '' : 'assets/images/breadcurmb/scratchwin.jpg';

        this.loadUserProgress();
        this.fetchPreviousPrizes();
        // this.setupCanvas();
        // this.newPrize();
      }

      ngOnDestroy(): void {
        localStorage.removeItem('mobile_number');
      }

      ngAfterViewInit() {
        this.fetchProducts();
        this.setupCanvas();
        this.fetchPreviousPrizes();
      }

      fetchPreviousPrizes(): void {

        const userCode = JSON.parse(this.profileData).user_code;
        const eventCode = localStorage.getItem('event_code') as string;
        const event_type = localStorage.getItem('event_type') as string;

        const formData = new FormData();
        formData.append('user_code', userCode);
        formData.append('event_code', eventCode);
        formData.append('token', this.token);

        this.productService.getPreviousScratchData(formData).subscribe({
            next: (res : any) => {
                if (res.response?.status === 1) {
                    const data = res.response.data;

                    // Get names & codes from comma-separated string
                    this.previousPrizes = data.products?.split(',') || [];

                    // Optional: restore scratchCount
                    this.scratchCount = this.previousPrizes.length;
                    this.chancesLeft = 3 - this.scratchCount;
                } else {
                    console.log('No previous prizes found');
                }
            },
            error: (err) => {
                console.error('Error fetching previous prizes', err);
            }
        });
      }

      loadUserProgress() {
        const savedChances = localStorage.getItem('chancesLeft');
        const savedProgress = localStorage.getItem('scratchedProgress');
        const savedPrize = localStorage.getItem('storedPrize');
        const savedPreviousPrizes = JSON.parse(localStorage.getItem('previousPrizes') || '[]');

        if (savedChances) {
            this.chancesLeft = parseInt(savedChances, 10);
        }

        if (savedProgress) {
            this.currentScratchProgress = parseFloat(savedProgress);
        }

        if (savedPrize) {
            this.storedPrize = savedPrize;
            this.prizeElRef.nativeElement.textContent = savedPrize;
        }

        if (savedPreviousPrizes.length > 0) {
            this.previousPrizes = savedPreviousPrizes;  // Load previous prizes from localStorage
        }

        this.displayedPrizes = this.previousPrizes.slice(0, 3);

        // Update the prize text for the user if there's progress.
        if (this.currentScratchProgress >= 0.3) {
            this.revealPrize();
        }
      }

      prevPrize() {
        console.log(this.currentPrizeIndex);
        if (this.currentPrizeIndex > 0) {
            this.currentPrizeIndex--;
            this.updateDisplayedPrizes();
        }
      }

      nextPrize() {
        console.log(this.currentPrizeIndex);
        if (this.currentPrizeIndex + 3 < this.previousPrizes.length) {
            this.currentPrizeIndex++;
            this.updateDisplayedPrizes();
        }
      }

      // Update the displayed prizes based on the current index
      updateDisplayedPrizes() {
          this.displayedPrizes = this.previousPrizes.slice(this.currentPrizeIndex, this.currentPrizeIndex + 3);
      }

      setupCanvas() {
        const canvas = this.scratchCanvasRef.nativeElement;
        this.ctx = canvas.getContext('2d')!;

        this.resizeCanvas();

        // window.addEventListener('resize', () => this.resizeCanvas());
        canvas.addEventListener('mousedown', () => this.scratching = true);
        canvas.addEventListener('mouseup', () => this.scratching = false);
        canvas.addEventListener('mousemove', (e) => this.handleScratch(e));

        canvas.addEventListener('touchstart', () => this.scratching = true);
        canvas.addEventListener('touchend', () => this.scratching = false);
        canvas.addEventListener('touchmove', (e) => this.handleScratch(e));
      }

      resizeCanvas() {
        const canvas = this.scratchCanvasRef.nativeElement;
        canvas.width = 300;
        canvas.height = 200;
        this.ctx.fillStyle = '#ed1d24';
        this.ctx.fillRect(0, 0, canvas.width, canvas.height);
        this.ctx.fillStyle = '#fff';
        this.ctx.textAlign = 'center';
        this.ctx.font = 'bold 20px Arial';
        this.ctx.fillText('Scratch to Reveal!', canvas.width / 2, canvas.height / 2);
        this.totalPixels = canvas.width * canvas.height;
        this.scratchedPixels = 0;
      }

      handleScratch(e: MouseEvent | TouchEvent) {
        if (!this.scratching || this.chancesLeft <= 0 || this.prizeRevealed) return;

        const canvas = this.scratchCanvasRef.nativeElement;
        const rect = canvas.getBoundingClientRect();
        const x = e instanceof MouseEvent ? e.clientX - rect.left : e.touches[0].clientX - rect.left;
        const y = e instanceof MouseEvent ? e.clientY - rect.top : e.touches[0].clientY - rect.top;

        this.ctx.globalCompositeOperation = 'destination-out';
        this.ctx.beginPath();
        this.ctx.arc(x, y, 20, 0, Math.PI * 2);
        this.ctx.fill();

        this.scratchedPixels += Math.PI * 20 * 20;
        const scratchedPercent = this.scratchedPixels / this.totalPixels;

        if (scratchedPercent >= 10.7 && !this.prizeRevealed) {
          this.revealPrize();
        }
      }
      
      // -------------------- Reveal & Save Prize --------------------
      revealPrize() {
        this.prizeElRef.nativeElement.textContent = this.selectedPrize;
        this.previousPrizes.push(this.selectedPrize);
        this.prizeRevealed = true;
        this.chancesLeft--;

        // Save prize to backend
        this.savePrizeToBackend();

        // Disable further scratch if 3 done
        if (this.chancesLeft === 0) {
          this.scratching = false;
        }
      }

      newPrize() {
        const unused = this.products.filter(p => !this.previousPrizes.includes(p.product_details.name));
        if (unused.length > 0) {
          const random = unused[Math.floor(Math.random() * unused.length)];
          this.selectedPrize = random.product_details.name;
          this.selectedPrizeCode = random.product_details.sku;
        } else {
          this.selectedPrize = 'No Prizes Left';
          this.selectedPrizeCode = '';
        }
        this.prizeElRef.nativeElement.textContent = '🎁 Scratch to Reveal!';
        this.resizeCanvas();
        this.prizeRevealed = false;
      }

      resetGame() {
        if (this.chancesLeft <= 0) return;
        this.newPrize();
      }

      savePrizeToBackend() {
        const userCode = JSON.parse(this.profileData).user_code;
        const eventCode = localStorage.getItem('event_code') as string;
        const event_type = localStorage.getItem('event_type') as string;

        const formData = new FormData();
        formData.append('productName', this.selectedPrize);
        formData.append('productCode', this.selectedPrizeCode);
        formData.append('user_code', userCode);
        formData.append('event_type', event_type);
        formData.append('event_code', eventCode);
        formData.append('chanceleft', this.chancesLeft.toString());
        formData.append('token', this.token);

        this.productService.saveScratchPrize(formData).subscribe({
            next: (res: any) => {
            console.log('Prize saved response:', res);
                if (res.response?.status === 1) {
                    console.log('Prize saved.');
                } else {
                    console.warn('Save failed.', res.response?.msg);
                }
            },
            error: (err: any) => {
                console.error('API error:', err);
            }
        });
      }

      public redirectToIndex() {
          // this.router.navigate(['/index']);
          // this.location.replaceState('/index');
          this.router.navigate(['/index'], { replaceUrl: true });
      }
    
      resetLinkColors() {
        const links = document.querySelectorAll('a');
        links.forEach(link => {
          link.style.color = 'blue';
          link.style.textDecoration = 'underline';
        });
      }

      isEventZero(): boolean {
        const event_code = localStorage.getItem('event');
        return event_code === '0';
      }

      isEventOne(): boolean {
        const event_code = localStorage.getItem('event');
        return event_code === '1';
      }

      fetchProducts(): void {
        const member_type = JSON.parse(this.profileData).category;
        const user_code = JSON.parse(this.profileData).user_code;
        const event_code = localStorage.getItem('event_code') as string;
        
        this.productService.fetchProducts1(event_code, this.categoryId, member_type, user_code, this.token)
          .subscribe(
            (response) => {
              console.log(response);
              if (response.response.data && response.response.data.length > 0) {
                this.products = response.response.data.map((product: { product_details: string }) => ({
                  ...product,
                  product_details: JSON.parse(product.product_details)
                }));

                // Map the fetched products to the prizes array
                this.prizes = this.products.map(product => {
                  return `${product.product_details.name}`;  // Adjust this based on your product data
                });

                this.voucher_category_id = this.products[0].voucher_category_id;
                this.categoryName = this.products[0]?.voucher_category_name;

                // Select the first product (or random, as per your logic)
                this.selectedProduct = this.products[0];
                this.newPrize(); // Call newPrize to reset canvas with new prize options
              } else {
                alert('You’ve already redeemed this month’s voucher. Please check back next month for exciting new rewards!');
              }
            },
            (error) => {
              console.error('API Error:', error);
            }
          );
      }
      
      // fetchProducts(): void {
      //   const member_type = JSON.parse(this.profileData).category;
      //   const user_code = JSON.parse(this.profileData).user_code;
      //   const event_code = localStorage.getItem('event_code') as string;
      //   this.productService.fetchProducts1(event_code,this.categoryId,member_type, user_code, this.token)
      //     .subscribe(
      //       (response) => {
      //         console.log(response);
      //         if (response.response.data && response.response.data.length > 0) {
      //           this.products = response.response.data.map((product: { product_details: string }) => ({
      //             ...product,
      //             product_details: JSON.parse(product.product_details)
      //           }));
      
      //           this.voucher_category_id = this.products[0].voucher_category_id;
      //           this.categoryName = this.products[0]?.voucher_category_name;
    
      //           this.selectedProduct = this.products[0];
    
      //           // if (this.selectedProduct && this.selectedProduct.product_details) {
      //           //   const tnc = this.selectedProduct.product_details.tnc;
      //           //   if (tnc) {
      //           //     this.termsAndConditions = tnc.content || '';
      //           //     this.termsLink = tnc.link || '';
      //           //   } else {
      //           //     this.termsAndConditions = '';
      //           //     this.termsLink = '';
      //           //     console.warn('Terms and Conditions are not available for the selected product.');
      //           //   }
      //           // }
                
      
      //         } else {
      //           // alert('Voucher settings not found.Please contact support');
      //           alert('You’ve already redeemed this month’s voucher. Please check back next month for exciting new rewards!');
      //         }
      //       },
    
    
      //       (error) => {
      //         // console.error('API Error:', error);
      //       }
      //     );
    
      // }
    
      openTermsLink(link: any): void {
        if (link) {
          window.open(link, '_blank');
        } else {
          alert('Terms and Conditions link is not available.');
        }
      }
    
      onProductSelect(product: any) {
        this.selectedProduct = {
          ...product,
          showTerms: false, 
          expanded: false,   
        };
      }
    
      // toggleTerms() {
      //   this.showTerms = !this.showTerms; //Togle k liye
      // }
    
      toggleTerms() {
        if (this.selectedProduct) {
          this.selectedProduct.showTerms = !this.selectedProduct.showTerms; //read more k liye
        }
      }
    
      toggleReadMore() {
        if (this.selectedProduct) {
          this.selectedProduct.expanded = !this.selectedProduct.expanded; // show more k liye
        }
      }
    
      // getDisplayedContent(): string {
      //   if (this.selectedProduct) {
      //     const content = this.selectedProduct.product_details.tnc.content;
      //     return this.selectedProduct.expanded ? content : content.slice(0, 200) + '...';
      //     return this.formatContent(this.selectedProduct.expanded ? content : content.slice(0, 200) + '...');
      //   }
      //   return '';
      // }
    
      getDisplayedContent(): string {
        if (this.selectedProduct) {
          const content = this.selectedProduct.product_details.tnc.content;
          // Get the displayed content based on whether it's expanded or not
          const displayedContent = this.selectedProduct.expanded ? content : content.slice(0, 200) + '...';
          // return this.formatContent(displayedContent);
          const formattedContent = this.formatContent(displayedContent);
          this.resetLinkColors();
        
          return formattedContent;
        }
        return '';
      }
    
      formatContent(content: string): string {
        const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(?=\s|$|[^\w.-])/g;
        const urlRegex = /(https?:\/\/[^\s<]+)/g;
      
        content = content.replace(/<br\s*\/?>/g, '');
        content = content.replace(/<li>/g, '').replace(/<\/li>/g, '');
      
        content = content.replace(urlRegex, (url: string) => {
          const encodedUrl = encodeURI(url);
          return `<a href="${encodedUrl}" target="_blank" style="color: blue; text-decoration: underline;">${encodedUrl}</a>`;
        });
      
        content = content.replace(emailRegex, (email: string) => {
          const cleanedEmail = email.split(/[\s<>,;]+/)[0];
          return `<a href="mailto:${cleanedEmail}" style="color: blue; text-decoration: underline;">${cleanedEmail}</a>`;
        });
      
        return content;
      }
    
      // formatContent(content: any): string {
      //   const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
      //   const urlRegex = /(https?:\/\/[^\s]+)/g;
    
      //   return content
      //     .replace(urlRegex, '<a href="$&" target="_blank" style="color: blue; text-decoration: underline;">$&</a>')
      //     .replace(emailRegex, '<a href="mailto:$&" style="color: blue; text-decoration: underline;">$&</a>');
      // }
    
      // onCardClick(product: any): void {
      //   this.selectedProduct = this.selectedProduct === product ? null : { ...product, quantity: 1 };
    
      //   setTimeout(() => { this.scroller.scrollToAnchor("giftCardDetails") }, 100);
    
      // }
    
      // onCardClick(product: any): void {
      //   if (this.selectedProduct === product) {
      //     this.selectedProduct = null;
      //   } else {
      //     this.selectedProduct = { ...product, selectedPrice: product.selectedPrice || 0 };
      //     if (this.selectedProduct.selectedPrice === 0) {
      //       this.selectedProduct.selectedPrice = product.product_details.price.min;
      //     }
      //     this.updateRemainingBalance(product);
      //     this.quantity = 1;
      //   }
    
      //   setTimeout(() => { this.scroller.scrollToAnchor("giftCardDetails"); }, 100);
      // }
    
      onCardClick(product: any): void {
        if (this.selectedProduct === product) {
            this.selectedProduct = null;
            this.showDetailsSection = false;
        } else {
            this.selectedProduct = { ...product };
            // , selectedPrice: null
            // if (product.selected_denominations && product.selected_denominations.length) {
            //     this.selectedProduct.selectedPrice = product.selected_denominations[0]; 
            // }
            if (
              product.product_details.price.type === 'SLAB' &&
              product.selected_denominations &&
              product.selected_denominations.length > 0
          ) {
              this.selectedProduct.selectedPrice = product.selected_denominations[0];
          }
            this.updateRemainingBalance(product);
            this.quantity = 1;
            this.showDetailsSection = true;
        }
    
        setTimeout(() => { this.scroller.scrollToAnchor("giftCardDetails"); }, 100);
      }

      // acceptPrize(prize: string): void {
      //   console.log("Prize selected:", prize);  // Log the prize name
      //   console.log("Products array:", this.products);  // Log the products array

      //   // Find the product based on the prize name directly
      //   const matchedProduct = this.products.find(p => p.name === prize);

      //   if (matchedProduct) {
      //       this.selectedProduct = { ...matchedProduct };

      //       // If there's SLAB pricing, select the first denomination
      //       if (
      //           matchedProduct.product_details?.price?.type === 'SLAB' &&
      //           matchedProduct.selected_denominations?.length > 0
      //       ) {
      //           this.selectedProduct.selectedPrice = matchedProduct.selected_denominations[0];
      //       }

      //       this.updateRemainingBalance(matchedProduct);
      //       this.quantity = 1;

      //       // Show the details section
      //       this.showDetailsSection = true;

      //       setTimeout(() => {
      //           // Scroll to the anchor if needed
      //           this.scroller.scrollToAnchor("giftCardDetails");
      //       }, 100);
      //   } else {
      //       console.warn("Selected prize does not match any product.");
      //   }
      // }

      acceptPrize(prize: string): void {
        console.log("Prize selected:", prize);  // Log the prize name
        console.log("Products array:", this.products);  // Log the products array

        // Find the product based on the prize name directly
        const matchedProduct = this.products.find(p => p.product_details.name === prize);

        if (matchedProduct) {
            this.selectedProduct = { ...matchedProduct };

            // If there's SLAB pricing, select the first denomination
            if (
                matchedProduct.product_details?.price?.type === 'SLAB' &&
                matchedProduct.selected_denominations?.length > 0
            ) {
                this.selectedProduct.selectedPrice = matchedProduct.selected_denominations[0];
            }

            this.updateRemainingBalance(matchedProduct);
            this.quantity = 1;

            // Show the details section
            this.showDetailsSection = true;

            setTimeout(() => {
                // Scroll to the anchor if needed
                this.scroller.scrollToAnchor("giftCardDetails");
            }, 100);
        } else {
            console.warn("Selected prize does not match any product.");
        }
      }

      // acceptPrize(): void {
      //   // Find the product from `products` list whose name matches the selectedPrize
      //   const matchedProduct = this.products.find(p => p.product_details.name === this.selectedPrize);

      //   if (matchedProduct) {
      //     this.selectedProduct = { ...matchedProduct };

      //     // Set selectedPrice if price type is SLAB
      //     if (
      //       matchedProduct.product_details.price.type === 'SLAB' &&
      //       matchedProduct.selected_denominations &&
      //       matchedProduct.selected_denominations.length > 0
      //     ) {
      //       this.selectedProduct.selectedPrice = matchedProduct.selected_denominations[0];
      //     }

      //     this.updateRemainingBalance(matchedProduct);
      //     this.quantity = 1;

      //     this.showDetailsSection = true;

      //     setTimeout(() => {
      //       this.scroller.scrollToAnchor("giftCardDetails");
      //     }, 100);
      //   } else {
      //     console.warn("Selected prize does not match any product.");
      //   }
      // }
    
      setIndex(index: number) {
        this.selectedIndex = index;
      }
    
      // onCheckboxChange(event: Event, product: any): void {
      //   const input = event.target as HTMLInputElement;
      //   const denomination = parseFloat(input.value);
    
      //   if (input.checked) {
      //     product.selectedPrice = denomination; // Set the selected denomination for the product
      //   }
    
      //   console.log('Selected denomination for product:', product.sku, product.selectedPrice);
      // }
    
    
      // onCheckboxChange(event: Event, product: any): void {
      //   const input = event.target as HTMLInputElement;
    
      //   product.selectedPrice = parseFloat(input.value);
    
      //   console.log('Selected denomination for product:', product.sku, product.selectedPrice);
      // }
    
      onCheckboxChange(event: Event, product: any): void {
        const input = event.target as HTMLInputElement;
        product.selectedPrice = parseFloat(input.value);
        console.log('Selected denomination for product:', product.sku, product.selectedPrice);
        this.updateRemainingBalance(product);
      }
    
    
      private updateRemainingBalance(product: any) {
        if (product.selectedPrice) {
            const totalSelectedPrice = product.selectedPrice * this.quantity;
            const newBalance = product.remaining_voucher_amount - totalSelectedPrice;
      
            if (newBalance >= 0) {
                this.remainingBalance = newBalance;
            } else {
                this.remainingBalance = 0;
                console.warn('Selected price exceeds remaining balance.');
                alert('You exceeded the remaining balance. Please try again later.');
            }
        } else {
            this.remainingBalance = product.remaining_voucher_amount;
        }
      
        this.vouchersAvailable = Math.floor(this.remainingBalance / 1000);
        console.log('Remaining Balance:', this.remainingBalance);
        console.log('Vouchers Available:', this.vouchersAvailable);
      }
    
      updateQuantity(newQuantity: number): void {
        this.quantity = newQuantity; // Update the quantity
        if (this.selectedProduct) {
            this.updateRemainingBalance(this.selectedProduct); // Pass the selected product
        }
      }
    
      isOrderValid(product: any): boolean {
        const isWithinMinMax = product.selectedPrice >= product.product_details.price.min && product.selectedPrice <= product.product_details.price.max;
        return isWithinMinMax || (product.selected_denominations && product.selected_denominations.length > 0 && product.selectedPrice !== null);
      }
    
      onNumericInputChange(product: any): void {
        console.log('Selected amount for product:', product.sku, product.selectedPrice);
      }
    
    // async placeOrder(product: any): Promise<void> {
    //     if (!product) {
    //         alert('Please select a product before placing an order.');
    //         return;
    //     }
    
    //     const hasDenominations = product.selected_denominations && product.selected_denominations.length > 0;
    
    //     if (hasDenominations) {
    //         if (product.selectedPrice === undefined || product.selectedPrice === null) {
    //             alert('Please select a denomination before placing an order.');
    //             return;
    //         }
    //     } else {
    //         if (product.selectedPrice < product.product_details.price.min || product.selectedPrice > product.product_details.price.max) {
    //             alert('Selected amount is out of the allowed range.');
    //             return;
    //         }
    //     }
    
    //     // Confirm order placement only once
    //     const confirmOrder = confirm('Are you sure you want to place this order?');
    //     if (!confirmOrder) {
    //         return;
    //     }
    
    //     // Deduct amount only after confirmation
    //     const totalSelectedPrice = product.selectedPrice * this.quantity; // Calculate total price
    //     const newBalance = product.remaining_voucher_amount - totalSelectedPrice;
    
    //     if (newBalance < 0) {
    //         alert('Insufficient balance to place this order.');
    //         return;
    //     }
    
    //     // Proceed with placing the order and updating the balance
    //     await this.attemptOrderPlacement(product);
    //     this.remainingBalance = newBalance; // Update remaining balance after placing the order
    //     console.log('Remaining Balance after Order:', this.remainingBalance);
    // }
    
        async placeOrder(product: any): Promise<void> {
          if (!product) {
              alert('Please select a product before placing an order.');
              return;
          }
        
          const hasDenominations = product.selected_denominations && product.selected_denominations.length > 0;
        
          if (hasDenominations) {
              if (product.selectedPrice === undefined || product.selectedPrice === null) {
                  alert('Please select a denomination before placing an order.');
                  return;
              }
          } else {
              if (product.selectedPrice < product.product_details.price.min || product.selectedPrice > product.product_details.price.max) {
                  alert('Selected amount is out of the allowed range.');
                  return;
              }
          }
        
          // Confirm order placement only once
          const confirmOrder = confirm('Are you sure you want to place this order?');
          if (!confirmOrder) {
              return;
          }
        
          // Deduct amount only after confirmation
          const totalSelectedPrice = product.selectedPrice * this.quantity; // Calculate total price
          const newBalance = product.remaining_voucher_amount - totalSelectedPrice;
        
          if (newBalance < 0) {
              alert("Looks like you've used up this month's referrals. Don't worry — you can try again next month!");
              // alert('Insufficient amount. You exceeded the remaining balance, Please try again later.');
              return;
          }
        
          // Proceed with placing the order and updating the balance
          await this.attemptOrderPlacement(product);
          this.remainingBalance = newBalance; // Update remaining balance after placing the order
          console.log('Remaining Balance after Order:', this.remainingBalance);
        }
    
      private async attemptOrderPlacement(product: any): Promise<void> {
        try {
            const architect_code = JSON.parse(this.profileData).user_code;
            const member_type = JSON.parse(this.profileData).category;
            const voucher_category_id = this.voucher_category_id;
            const event_code = localStorage.getItem('event_code') as string;
            const isEventOngoing = localStorage.getItem('event') === '1';

            console.log(voucher_category_id);

    
            const formData: FormData = new FormData();
            formData.append('sku', product.sku || '');
            formData.append('price', product.selectedPrice.toString());
            formData.append('qty', this.quantity.toString());
            formData.append('giftMessage', product.product_details.description || '');
            formData.append('architect_code', architect_code);
            formData.append('bearerToken', this.bearerToken);
            formData.append('voucher_category_id', voucher_category_id);
            formData.append('member_type', member_type);
            formData.append('sync_only', this.quantity <= 4 ? 'true' : 'false');
            formData.append('event_code', event_code);

            // const formDataDebug: any = {};
            // formData.forEach((value, key) => {
            //   formDataDebug[key] = value;
            // });
            // console.log(formDataDebug);
    
            this.showLoadingIndicator(); 
    
            this.productService.createOrder1(formData).subscribe(
              async (response) => {
                  this.hideLoadingIndicator();
                  console.log(response);
          
                  const responseData = response.response || response;
          
                  if (!responseData) {
                      alert('Unexpected Error. Please try again later.');
                      return;
                  }

                  const order_refno = responseData?.data.refno;
                  const mobile_number = localStorage.getItem('mobile_number');
          
                  const { status, msg, data } = responseData;
          
                  if (status === 1) {
                      alert('Your JOYReward order has been placed successfully! You will receive the GIFT CARD CODE through the WhatsApp BOT and registered Email ID within 2 hours.');
                      // this.router.navigate(['/index']);
                      
                      if (isEventOngoing && mobile_number && order_refno) {
                          this.categoryService.updateRefNo(architect_code, order_refno, mobile_number)
                          .subscribe(
                              (updateResponse: any) => {
                                  if (updateResponse?.response?.status === 1) {
                                      console.log('Referral refno updated successfully.');
                                  } else {
                                      console.warn('Referral update failed:', updateResponse?.response?.msg);
                                  }
                                  localStorage.removeItem('mobile_number');
                                  window.onbeforeunload = null;
                              },
                              (error: any) => {
                                  console.error('Error calling updateRefNo API:', error);
                                  localStorage.removeItem('mobile_number');
                              }
                          );
                      }

                      this.redirectToIndex();
                  } else if (status === 'PROCESSING') {
                      const orderData = data.api_response.data;
                      alert(`Your order is in process. Order ID: ${orderData.orderId}. We will let you know when it's processed.`);
                      // this.router.navigate(['/index']);
                      this.redirectToIndex();
                  } else if (status === 0) {
                    if (data && data.data && data.data.code === 401 && data.data.message === 'oauth_problem=token_rejected') {
                      await this.handleTokenRejection(product);
                  } else {
                      switch (msg) {
                          case 'Regret, you just missed it.Stay tuned for more exiting rewards soon.':
                              alert('Regret, you just missed it.Stay tuned for more exiting rewards soon.');
                              break;
                          case 'Regret, you just missed it.Stay tuned for more exiting rewards soon.':
                              alert('Regret, you just missed it.Stay tuned for more exiting rewards soon.');
                              break;
                          case 'Order exceeds the allowed number of vouchers.':
                              alert('Order exceeds the allowed number of vouchers. Please contact support.');
                              break;
                          case 'There is some problem in the server.':
                              alert('There is a server issue. Please try again later.');
                              break;
                          case 'You do not have sufficient amount.':
                              alert('You do not have sufficient amount. Please try again.');
                              break;
                          case 'You exceeded the remaining balance. Please try again later.':
                              alert('You exceeded the remaining balance. Please try again later.');
                              break;
                          case 'Insufficient amount. You exceeded the remaining balance, Please try again later.':
                              alert('Insufficient amount. You exceeded the remaining balance. Please try again later.');
                              break;
                          case 'API Error':
                              alert('Request failed. Please check your credentials and try again.');
                              break;
                          default:
                              alert(msg || 'Failed to place the order. Please try again.');
                      }
                    }
                  } else {
                      alert('Unexpected response from the server. Please try again later.');
                  }
              },
              async (error) => {
                  this.hideLoadingIndicator();
                  console.error('Order placement error:', error);
                  const errorMsg = this.getErrorMessage(error);
    
                  if (errorMsg === 'oauth_problem=token_rejected') {
                    await this.handleTokenRejection(product);
                } else {
                    alert(`Error: ${errorMsg || 'An unexpected error occurred. Please try again.'}`);
                }
              }
          );
        } catch (error) {
            this.hideLoadingIndicator();  
            console.error('Error ensuring bearer token:', error);
            alert('An error occurred while processing your order. Please try again.');
        }
      }

      // private async attemptOrderPlacement(product: any): Promise<void> {
      //   try {
      //       const architect_code = JSON.parse(this.profileData).user_code;
      //       const member_type = JSON.parse(this.profileData).category;
      //       const voucher_category_id = this.voucher_category_id;
    
      //       const formData: FormData = new FormData();
      //       formData.append('sku', product.sku || '');
      //       formData.append('price', product.selectedPrice.toString());
      //       formData.append('qty', this.quantity.toString());
      //       formData.append('giftMessage', product.product_details.description || '');
      //       formData.append('architect_code', architect_code);
      //       formData.append('bearerToken', this.bearerToken);
      //       formData.append('voucher_category_id', voucher_category_id);
      //       formData.append('member_type', member_type);
      //       formData.append('sync_only', this.quantity <= 4 ? 'true' : 'false');
    
      //       this.showLoadingIndicator(); 
    
      //       this.productService.createOrder(formData).subscribe(
      //         async (response) => {
      //             this.hideLoadingIndicator();
      //             console.log(response);
          
      //             const responseData = response.response || response;

      //             const order_refno = responseData?.refno;
      //             const mobile_number = localStorage.getItem('mobile_number');
          
      //             if (!responseData) {
      //                 alert('Unexpected Error. Please try again later.');
      //                 return;
      //             }
          
      //             const { status, msg, data } = responseData;
          
      //             if (status === 1) {
      //                 alert('Your JOYReward order has been placed successfully! You will receive the GIFT CARD CODE through the WhatsApp BOT and registered Email ID within 2 hours.');
                      
      //                 if (mobile_number && order_refno) {
      //                       this.categoryService.updateRefNo(architect_code, order_refno, mobile_number)
      //                         .subscribe((updateResponse: any) => {
      //                             if (updateResponse?.response?.status === 1) {
      //                                 console.log('Referral refno updated successfully.');
      //                             } else {
      //                                 console.warn('Referral update failed:', updateResponse?.response?.msg);
      //                             }
      //                             localStorage.removeItem('mobile_number');
      //                             window.onbeforeunload = null;
      //                         }, (error: any) => {
      //                             console.error('Error calling updateRefNo API:', error);
      //                             localStorage.removeItem('mobile_number');
      //                         });
      //                   }
      //                 // this.router.navigate(['/index']);
      //                 this.redirectToIndex();
      //             } else if (status === 'PROCESSING') {
      //                 const orderData = data.api_response.data;
      //                 alert(`Your order is in process. Order ID: ${orderData.orderId}. We will let you know when it's processed.`);
      //                 // this.router.navigate(['/index']);
      //                 this.redirectToIndex();
      //             } else if (status === 0) {
      //               if (data && data.data && data.data.code === 401 && data.data.message === 'oauth_problem=token_rejected') {
      //                 await this.handleTokenRejection(product);
      //             } else {
      //                 switch (msg) {
      //                     case 'Regret, you just missed it.Stay tuned for more exiting rewards soon.':
      //                         alert('Regret, you just missed it.Stay tuned for more exiting rewards soon.');
      //                         break;
      //                     case 'Regret, you just missed it.Stay tuned for more exiting rewards soon.':
      //                         alert('Regret, you just missed it.Stay tuned for more exiting rewards soon.');
      //                         break;
      //                     case 'Order exceeds the allowed number of vouchers.':
      //                         alert('Order exceeds the allowed number of vouchers. Please contact support.');
      //                         break;
      //                     case 'There is some problem in the server.':
      //                         alert('There is a server issue. Please try again later.');
      //                         break;
      //                     case 'You do not have sufficient amount.':
      //                         alert('You do not have sufficient amount. Please try again.');
      //                         break;
      //                     case 'You exceeded the remaining balance. Please try again later.':
      //                         alert('You exceeded the remaining balance. Please try again later.');
      //                         break;
      //                     case 'Insufficient amount. You exceeded the remaining balance, Please try again later.':
      //                         alert('Insufficient amount. You exceeded the remaining balance. Please try again later.');
      //                         break;
      //                     case 'API Error':
      //                         alert('Request failed. Please check your credentials and try again.');
      //                         break;
      //                     default:
      //                         alert(msg || 'Failed to place the order. Please try again.');
      //                 }
      //               }
      //             } else {
      //                 alert('Unexpected response from the server. Please try again later.');
      //             }
      //         },
      //         async (error) => {
      //             this.hideLoadingIndicator();
      //             console.error('Order placement error:', error);
      //             const errorMsg = this.getErrorMessage(error);
    
      //             if (errorMsg === 'oauth_problem=token_rejected') {
      //               await this.handleTokenRejection(product);
      //           } else {
      //               alert(`Error: ${errorMsg || 'An unexpected error occurred. Please try again.'}`);
      //           }
      //         }
      //     );
      //   } catch (error) {
      //       this.hideLoadingIndicator();  
      //       console.error('Error ensuring bearer token:', error);
      //       alert('An error occurred while processing your order. Please try again.');
      //   }
      // }
    
      private async handleTokenRejection(product: any) {
        try {
            console.log('Attempting to update bearer token...');
            await this.authManager.updateBearerToken();
            this.bearerToken = localStorage.getItem('bearerToken');
            console.log('Updated bearer token:', this.bearerToken);
            // await this.attemptOrderPlacement(product);
            if (this.bearerToken) {
              await this.attemptOrderPlacement(product);
          } else {
              throw new Error('Bearer token is empty after refresh');
          }
        } catch (refreshError) {
            console.error('Failed to refresh token:', refreshError);
            alert('Your session is expired. You will be logged out now. Please login and try again.');
            this.authManager.handleTokenRejected();
        }
      }
    
      // private async attemptOrderPlacement(product: any): Promise<void> {
      //   try {
      //     // const bearerToken = await this.authManager.ensureBearerToken();
    
      //     const architect_code = JSON.parse(this.profileData).user_code;
      //     const member_type = JSON.parse(this.profileData).category;
      //     const voucher_category_id = this.voucher_category_id;
    
      //     const formData: FormData = new FormData();
      //     formData.append('sku', product.sku || '');
      //     formData.append('price', product.selectedPrice.toString());
      //     formData.append('qty', this.quantity.toString());
      //     formData.append('giftMessage', product.product_details.description || '');
      //     formData.append('architect_code', architect_code);
      //     formData.append('bearerToken', this.bearerToken);
      //     formData.append('voucher_category_id', voucher_category_id);
      //     formData.append('member_type', member_type);
      //     formData.append('sync_only', this.quantity <= 4 ? 'true' : 'false');
    
      //     this.showLoadingIndicator();  // Show loading indicator
    
      //     this.productService.createOrder(formData).subscribe(
      //       async (response) => {
      //         this.hideLoadingIndicator();  // Hide loading indicator
    
      //         const status = response?.response?.data?.data?.status;
    
      //         if (status === 'PROCESSING') {
      //           alert(`Your Order is in process. Order ID: ${response.response.data.data.orderId} we will let you know when it's processed`);
      //         } else if (response?.response?.status === 1) {
      //           // console.log('Order placed successfully:', response);
      //           alert('Order placed successfully!');
      //         } else {
      //           const errorMsg = this.getErrorMessage(response);
      //           // console.log('Failed to place the order:', response);
    
      //           if (errorMsg === 'oauth_problem=token_rejected') {
      //             try {
      //               // await this.authManager.fetchBearerToken();
      //               await this.authManager.updateBearerToken();
      //               this.bearerToken = localStorage.getItem('bearerToken');
      //               await this.attemptOrderPlacement(product);
      //             } catch (refreshError) {
      //               console.error('Failed to refresh token:', refreshError);
      //               alert('There is some issue with the server, please hold on for a moment and try again.');
      //               this.authManager.handleTokenRejected();
      //             }
      //           } else {
      //             // alert(`Failed to place the order: ${errorMsg}`);
      //             alert(`Failed to place the order.`);
      //           }
      //         }
      //       },
      //       async (error) => {
      //         this.hideLoadingIndicator();  // Hide loading indicator
    
      //         console.error('Order placement error:', error);
      //         const errorMsg = this.getErrorMessage(error);
      //         alert(`Error: ${errorMsg}`);
    
      //         if (error.error && error.error.message.includes('oauth_problem=token_rejected')) {
      //           alert('An error occurred while processing your order. Please login again.');
      //           this.authManager.handleTokenRejected();
      //         }
      //       }
      //     );
      //   } catch (error) {
      //     this.hideLoadingIndicator();  // Hide loading indicator
      //     console.error('Error ensuring bearer token:', error);
      //     alert('An error occurred while processing your order. Please try again.');
      //   }
      // }
    
    
      private showLoadingIndicator(): void {
        // Create a loading spinner or message
        const loadingIndicator = document.createElement('div');
        loadingIndicator.id = 'loadingIndicator';
        loadingIndicator.style.position = 'fixed';
        loadingIndicator.style.top = '0';
        loadingIndicator.style.left = '0';
        loadingIndicator.style.right = '0';
        loadingIndicator.style.bottom = '0';
        loadingIndicator.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        loadingIndicator.style.color = 'white';
        loadingIndicator.style.display = 'flex';
        loadingIndicator.style.justifyContent = 'center';
        loadingIndicator.style.alignItems = 'center';
        loadingIndicator.style.zIndex = '9999';
        loadingIndicator.innerText = "Processing... Please don't refresh the page until the order is processed.";  // Loading text
        document.body.appendChild(loadingIndicator);
      }
    
      private hideLoadingIndicator(): void {
        const loadingIndicator = document.getElementById('loadingIndicator');
        if (loadingIndicator) {
          loadingIndicator.remove();  // Remove loading indicator from DOM
        }
      }
    
      private getErrorMessage(response: any): string {
        if (response?.response?.data?.data?.message) {
          return response.response.data.data.message;
        }
        if (response?.response?.msg) {
          return response.response.msg;
        }
        if (response?.error?.data?.message) {
          return response.error.data.message;
        }
        return 'An unexpected error occurred. Please try again later.';
      }
    
      blockManualInput(event: KeyboardEvent): void {
        const allowedKeys = ['ArrowUp', 'ArrowDown', 'Tab', 'Backspace', 'Delete'];
    
        if (!allowedKeys.includes(event.key)) {
            event.preventDefault();
        }
      }


}

